import { useEffect } from 'react';
import * as THREE from 'three';
import { LocationNames, Locations } from './Location';
import { ShadowMaterial } from 'three';

/* ---------- LOCATIONS ---------- */
const isLocationObj = (str) => (LocationNames.ALL.some(loc => Locations[loc].positionAnchorName == str));
const isLocationObjMatch = (str, location) => (str == (Locations[location] ?? {}).positionAnchorName);

/* ---------.- SEASONS ---------- */
export const Seasons = {
	SPRING: 'Spring',
	SUMMER: 'Summer',
	AUTUMN: 'Autumn',
	WINTER: 'Winter',
};
Seasons.ALL = Object.values(Seasons);
const isSeasonObj = (str) => Seasons.ALL.some(season => (season == str));
const isSeasonObjMatch = (str, season) => (str == season);
const SeasonsData = {
	[Seasons.SPRING]: { text: 'Frühling', emoji: '🌸' },
	[Seasons.SUMMER]: { text: 'Sommer',   emoji: '☀️' },
	[Seasons.AUTUMN]: { text: 'Herbst',   emoji: '🍂' },
	[Seasons.WINTER]: { text: 'Winter',   emoji: '❄️' },
}
Seasons.getText = (season) => (SeasonsData[season] ?? {}).text;
Seasons.getEmoji = (season) => (SeasonsData[season] ?? {}).emoji;

/* ---------- FOUNTAINS ---------- */
export const Fountains = {
	CLASSICAL: 'Classical',
	ROUND: 'Round',
	WATERPLAY: 'Waterplay',
};
Fountains.ALL = Object.values(Fountains);
const fountainPrefix = 'Fountain_';
const isFountainObj = (str) => Fountains.ALL.some(fountain => (str == `${fountainPrefix}${fountain}`));
const isFountainObjMatch = (str, fountain) => (str == `${fountainPrefix}${fountain}`);
const FountainsData = {
	[Fountains.CLASSICAL]: { text: 'Klassisch' },
	[Fountains.ROUND]:     { text: 'Rund' },
	[Fountains.WATERPLAY]: { text: 'Wasserspiel' },
};
Fountains.getText = (fountain) => (FountainsData[fountain] ?? {}).text;

/* ---------- CITY ENVIRONMENT ---------- */
export function CityEnvironment({ location, model, season, fountain, inOverview, setLocationAnchorOffset = () => {} }) {
	useEffect(() => {
		model.scene.traverse((obj) => {
			if (obj.isMesh) {
				obj.receiveShadow = true;
				obj.castShadow = true;
				/*
				if (obj.material && obj.name.toLowerCase().indexOf('metal') == -1) {
					obj.material.metalness = 0;
				}
				//*/

				if (obj.material && obj.material.map && obj.material.map.isTexture) {
					obj.material.map.minFilter = THREE.LinearMipMapNearestFilter;
					obj.material.map.needsUpdate = true;
				}
			}
		});
	}, []);

	useEffect(() => {
		model.scene.traverse((obj) => {
			if (obj.name === Locations[location].positionAnchorName) {
				const pos = obj.position;
				setLocationAnchorOffset([pos.x, pos.y, pos.z]);
			}
			if (isLocationObj(obj.name)) {
				obj.visible = inOverview || isLocationObjMatch(obj.name, location);
			}
			if (obj.name === 'Stadtmodell') {
				obj.material.colorWrite = inOverview;
				obj.material.depthWrite = true;
			}
			if (obj.name === 'ShadowPlane') {
				obj.material = new ShadowMaterial();
				obj.material.opacity = 0.3;
			}
		});
	}, [location, inOverview]);

	useEffect(() => {
		model.scene.traverse((obj) => {
			if (isSeasonObj(obj.name)) {
				obj.visible = isSeasonObjMatch(obj.name, season);
			}
		});
	}, [season]);

	useEffect(() => {
		model.scene.traverse((obj) => {
			if (isFountainObj(obj.name)) {
				obj.visible = isFountainObjMatch(obj.name, fountain);
			}
		});
	}, [fountain]);

	return <>
		<group>
			<primitive
				object={model.scene}
				castShadow={true}
				receiveShadow={true}
			/>
		</group>
	</>;
}

